'use es6';

import styled from 'foundations-theming/utils';
import PropTypes from 'prop-types';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useTheme } from 'styled-components';

/* @bend-expect no-styled-foundations-components */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const QuotaFlagContainer = styled(TFlex).withConfig({
  displayName: "QuotaFlag__QuotaFlagContainer",
  componentId: "sc-1667vri-0"
})(["position:absolute;bottom:24px;height:187px;pointer-events:none;transform:", ";"], ({
  reversed
}) => reversed ? 'translateX(100%)' : 'scale(-1, 1)');
const FormattedCurrencyContainer = styled.div.withConfig({
  displayName: "QuotaFlag__FormattedCurrencyContainer",
  componentId: "sc-1667vri-1"
})(["padding-inline:", ";padding-block-start:3px;white-space:nowrap;font-weight:600;font-size:12px;transform:", ";"], ({
  theme
}) => theme.space['200'], ({
  reversed
}) => reversed ? 'none' : 'scale(-1, 1)');
const QuotaLabelContainer = styled.div.withConfig({
  displayName: "QuotaFlag__QuotaLabelContainer",
  componentId: "sc-1667vri-2"
})(["text-align:", ";text-transform:uppercase;transform:", ";"], ({
  reversed
}) => reversed ? 'left' : 'right', ({
  reversed
}) => reversed ? 'none' : 'scale(-1, 1)');
const QuotaFlag = ({
  quota,
  reversed,
  style,
  currencyCode
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(QuotaFlagContainer, {
      flexDirection: "column",
      style: Object.assign({}, style),
      minBlockSize: "187px",
      maxInlineSize: "50px",
      reversed: reversed,
      children: [/*#__PURE__*/_jsx(QuotaLabelContainer, {
        reversed: reversed,
        children: /*#__PURE__*/_jsx(Text, {
          marginBlock: 200,
          typography: "detail-200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'reporting-ui-components.customWidgets.forecastWidget.quotaLabel'
          })
        })
      }), /*#__PURE__*/_jsx(Flex, {
        flexGrow: 1,
        borderInlineStartWidth: 200,
        borderInlineStartStyle: "solid",
        borderInlineStartColor: "do-not-use-obsidian",
        flexDirection: "row-reverse",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "stretch",
          blockSize: "30px",
          children: [/*#__PURE__*/_jsx(View, {
            backgroundColor: "do-not-use-cirrus",
            children: /*#__PURE__*/_jsx(FormattedCurrencyContainer, {
              reversed: reversed,
              children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
                value: quota,
                precision: 0,
                currencyCode: currencyCode
              })
            })
          }), /*#__PURE__*/_jsxs("svg", {
            fill: theme.color['do-not-use-cirrus'],
            width: "10px",
            viewBox: "0 0 30 90",
            transform: "scale (-1, 1)",
            children: [/*#__PURE__*/_jsx("polygon", {
              points: "0,90 30,90 30,45"
            }), /*#__PURE__*/_jsx("polygon", {
              points: "0,0  30,0  30,45"
            })]
          })]
        })
      })]
    })
  });
};
QuotaFlag.propTypes = {
  quota: PropTypes.number.isRequired,
  reversed: PropTypes.bool.isRequired,
  style: PropTypes.object,
  currencyCode: PropTypes.string.isRequired
};
export default QuotaFlag;